import { IConfig } from './contract/config.contract';

export class Constants {
  public static ApiBaseUrl: string;
  public static GooglAnalyticsId: string;
  public static PublicPath: string;
  public static SupportMailUrl: string;

  public static init(config: IConfig): void {
    this.ApiBaseUrl = config.apiBaseUrl;
    this.PublicPath = config.publicPath;
    this.GooglAnalyticsId = config.googleAnalyticsId;
    this.SupportMailUrl = config.supportMailUrl;
  }
}
